<template>
  <emd-modal
    :open="isOpen"
    has-header
    has-footer
    @close="() => $emit('onClose')"
  >
    <template v-slot:header>
      <h2>
        {{ $t('modal.pix.delete-pix-key-modal.title') }}
      </h2>
    </template>
    <template v-slot:content>
      <emd-alert
        v-if="error"
        variant="danger"
        :title="$t('account.settings.alert.error-title')"
        @cancel="error = null"
      >
        <template v-slot:content>
          {{ error }}
        </template>
      </emd-alert>
      <emd-alert
        variant="info"
        noClose
        :title="$t('modal.pix.delete-pix-key-modal.disclaimer')"
      >
        <template slot="content">
          {{ $t('modal.pix.delete-pix-key-modal.paragraph-1') }}
        </template>
      </emd-alert>
      <div class="eu-display_flex eu-mt_5">
        <emerald-icon icon="check" />
        <p>
          {{ $t('modal.pix.delete-pix-key-modal.paragraph-2.half-1') }}
          <strong>{{ accountName }}</strong>
          {{ $t('modal.pix.delete-pix-key-modal.paragraph-2.half-2') }}
        </p>
      </div>
    </template>
    <template v-slot:footer>
      <div class="input-container eu-display_flex eu-column">
        <passwordConfirmation
          :value="pass"
          data-testid="input-pass"
          v-model="pass"
        />
        <div class="button-container eu-mt_3 eu-display_flex eu-justify_end">
          <emd-button
            data-testid="button-cancel"
            type="text"
            :disabled="isLoad"
            :text="$t('modal.pix.delete-pix-key-modal.button-1')"
            @click="() => $emit('onCancel')"
          />
          <emd-button
            data-testid="button-delete-key"
            color="danger"
            :disabled="pass === '' || isLoad"
            :text="$t('modal.pix.delete-pix-key-modal.button-2')"
            @click="onSubmit()"
          />
        </div>
      </div>
    </template>
  </emd-modal>
</template>
<script>
import {
  EmdModal,
  EmdButton,
  EmdAlert,
  EmeraldIcon
} from 'emerald-vue/src/components'
import PasswordConfirmation from '@/components/project/molecules/PasswordConfirmation'

export default {
  name: 'ModalDeleteKey',
  components: {
    EmdModal,
    EmeraldIcon,
    EmdButton,
    EmdAlert,
    PasswordConfirmation
  },
  props: {
    accountName: String,
    isOpen: Boolean,
    error: String,
    isLoad: Boolean
  },
  data () {
    return {
      pass: ''
    }
  },
  methods: {
    onSubmit () {
      this.$emit('onDelete', window.btoa(this.pass))
    }
  }
}
</script>
<style scoped>
.input-container {
  width: 100%;
}
@media (max-width: 600px) {
  .button-container {
    padding-top: 50px;
    justify-content: space-evenly;
  }
}
</style>
